<template>
  <div v-if="decryptMemId()">
    <common ref="common"/>
        <v-row no-gutters >
          <v-col class="pt-2 pb-2">
            <v-card
              class="mx-auto rounded-xl mb-2 ma-4"
              elevation="24"
              max-width="100%"
            >
              <v-card-title style="padding-left: 25px;"> Welcome, {{ userModel.name }} </v-card-title>
              <v-card-subtitle style="padding-left: 25px;">
                Together, we build a resilient and flourishing merchant community.
              </v-card-subtitle>
              <v-card-text>
              <TrcsDues :userModel="userModel" @getPaymentConfirmation="getPaymentConfirmation"/>
            </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <DashboardScheme v-if="userModel.id" :memberId="userModel.id" @loadingChange="(e)=> $emit('loadingChange',e)"/>

        <Events class="mb-7"/>
        <v-bottom-sheet v-model="pymtSheetIsOpen">
          <PaymentView v-if="pymtSheetIsOpen" :memberId="userModel.id" :amountPayable="amountPayable" @loadingChange="(e)=> $emit('loadingChange',e)"/>
        </v-bottom-sheet>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import dayjs from "dayjs";
import { ValidationObserver,ValidationProvider } from "vee-validate";
export default {
  components:{
    TrcsDues: () => import("@/components/wesupport/dashboardComponents/TrcsDues.vue"),
    DashboardScheme: () => import("@/components/wesupport/dashboard/DashboardScheme.vue"),
    Events:()=>import("@/components/wesupport/dashboardComponents/events/Events.vue"),    
    ConfirmBox: () => import("@/components/tools/toolbox/ConfirmBox.vue"),
    common:()=>import("@/components/tools/common.vue"),
    PaymentView:()=>import("@/components/wesupport/payment/PaymentView.vue"),    
    ValidationObserver,ValidationProvider
},
  data: () => ({
    events:[{date:"2023-04-05",
    time:"02:45 PM",
    event:"Annual General Body Meeting",
    announcement:"We are pleased to inform you that the Annual General Body Meeting "},
    {date:"2023-04-05",
    time:"02:45 PM",
    event:"Annual General Body Meeting",
    announcement:"We are pleased to inform you that the Annual General Body Meeting "},
    {date:"2023-04-05",
    time:"02:45 PM",
    event:"Annual General Body Meeting",
    announcement:"We are pleased to inform you that the Annual General Body Meeting "},
    ],
    items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
        upcomingDues:[],
    recentTransactions: [],
    userModel: {},
    show:true,
    amountPayable:null,
    pendingPayment:false,
    pymtSheetIsOpen: false,
    enterAmtProvision:false,
    customPymtAmy:null
  }),
  mounted() {
    this.getUserDetails();
  },
  watch:{
    pymtSheetIsOpen(nv){
      if(!nv){
        this.amountPayable = null;
        this.pendingPayment = false;
      }
    }
  },
  methods: {
    
    dateFormat(d) {
      return dayjs(d).format("DD-MM-YYYY");
    },
    getUserDetails() {
      if(this.decryptMemId()){
        var common = this.$refs.common;
      this.$emit("loadingChange",true);
      var url1 = `/api/wesupport/Member/getMemIdByMobNumber?memberId=${this.decryptMemId()}&App=SU`;
      callApi(url1, "get", "")
        .then((response) => {
          this.userModel = response.data.data;
          // console.log(self.userModel);
        })
        .catch((error) => {
          //console.log("Error :" + error);
          common.ManageResponse(error.response);
        })
        .finally(()=>{
          this.$emit("loadingChange",false);
        });
      }
    },
    getPaymentConfirmation(pp, amt){
      this.amountPayable = amt;
      this.pendingPayment = pp;
      this.openPaymentConfirm();
    },
     openPaymentConfirm(){
      this.pymtSheetIsOpen = true
    },
    closePaymentConfirm(){
      this.pymtSheetIsOpen = false;
    },
    proceedPayment(amt){
      let url = `/api/wesupport/payment/generateOrder?memberId=${this.decryptMemId()}&amount=${amt}`;
      callApi(url,"post","")
      .then((res)=>{
        window.open(res.data.data,"_self");
      })
      .catch((err)=>{
        this.closePaymentConfirm();
        this.$refs.common.ManageResponse(err.response);
      })    
    },
    paymentConfirmed(confirm){
      if(confirm){
        this.$refs.apValidationRef.validate()
        .then((res)=>{
          console.log(res);
        })
        .catch((err)=>{
          console.log(err);
        })
      }else{
        this.$refs.paymentConfirm.close();
      }
    }
  },
};
</script>
<style>
.title-style {
  text-align: center !important;
  padding-bottom: 50px;
  padding-top: 50px;
  padding-right: 50px;
  padding-left: 50px;
}
.transparent-element {
    opacity: 0.5; /* This makes the background of the element red and 50% transparent */
}
</style>